export const FLOW_VALIDATION_MESSAGES = {
  FLOW_ENTRY_ID_NOT_FOUND: 'This form references a flow entry that no longer exists.',
  FLOW_ENTRY_NOT_AN_ENTRY:
    'This form points at another form that is not configured as a flow entry.',
  FLOW_CONFIG_ON_NON_ENTRY: 'Flow settings can only be configured on the flow entry.',
  FLOW_CONFIG_MISSING_TITLE: 'Flow title is required.',
  FLOW_MEMBER_UNREACHABLE: 'This flow step is not reachable from the flow entry on the canvas.',
  FLOW_MEMBER_IN_MULTIPLE_FLOWS: 'This form is a member of more than one flow.',
};

export const getFlowValidationMessage = code => FLOW_VALIDATION_MESSAGES[code];
